import { ArrowRight } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const ArrowRightIcon = createLucideIcon(ArrowRight);
